<template>
  <div class="rating-view">
    <div
      v-for="i in 5"
      :key="i"
      class="rating"
      :class="{
        fill: i <= ratingInt,
        'not-filled': i > ratingInt,
        small: isSmall
      }"
    >
      <div
        v-if="i > ratingInt && widthPercent"
        class="rating fill half"
        :class="{ small: isSmall }"
        :style="`width: ${widthPercent}%`"
      ></div>
    </div>
    <!-- <div class="rating not-filled">
			<div class="rating fill half" style="width: 50%"></div>
		</div> -->
  </div>
</template>
<script>
export default {
  props: {
    rating: {
      type: Number,
      default: () => 0.0
    },
    isSmall: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {
    ratingInt() {
      return Math.floor(this.rating);
    },
    widthPercent() {
      return (this.rating - Math.floor(this.rating)) * 100;
    }
  }
};
</script>
<style lang="scss" scoped>
.rating-view {
  display: flex;
  white-space: nowrap;
  align-items: center;

  .rating {
    display: inline-block;
    text-align: left;
    margin: 0 2px;
    background-size: cover;
    height: 18px;
    width: 18px;

    &.fill {
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAaCAYAAABGiCfwAAAACXBIWXMAABCcAAAQnAEmzTo0AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAHGSURBVHgBvZXPbcIwFMY/O6XnIFEkbmEC6AawQSuB1FvpBCUTtJ0AMUHhVgkObFBGYIOmp0r9I1CPBPxqk0JJcCAm0E+KIufZ/vmL37MZDNWqvzc4+KOAuHF7+Y7JWA5DcVh362+zsQZSrgByghY5QftIsKgbU3eJYWFXS5m5SwyLc2HiLhFM72qp5O7Yrg6tizeHZ06f42GLaTzhT6vuoOBhF0xNCCtTlj5ti6gEzhwiVpYhW0JsGImNGCMPgrw58Co/jDCbeWohrF3/etm+6kOJeWrPJvgncWFNL5V1HFVsJPzv8989G9s8I1QSlHFwLUAyeYqTVTYeB/gHUq1VnbmD7ET4vMoYBjiASM6zDlqgdR3btc+OjFxjTwlC1+3nGtHvsUWdoiQmt71cVhfQHldq/1LUnh2MTwjDySxdkmR8B4lhxAyPqIjmKCeHARWkEePJYRZHCVtEhOG2OLh+v7Uwgv43BLXjF5v9XFVYflGQ6Oon5drFbqR+cJLMxyGIdEKgB7d/NtzofyWvp5l1zxkP1aXwraw6KMKLiGotkxREEFWVEx1IyX0qeG4/31BOQ783JiM3pK75Vu2jgj2kxsmnqYv9APMhw88zf76oAAAAAElFTkSuQmCC);
    }

    &.not-filled {
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAaCAYAAACkVDyJAAAACXBIWXMAABCcAAAQnAEmzTo0AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGaSURBVHgBvZZdcoIwFIUv+POMO4grkD46o44soSuoS+gO2u6k3YE7wFEZXtlB0xWUdwbouR1wbCRI+Ok34yQSwskJ90SJDAmCYHc+n3NuqQU2GZLn+ct1O6hg4UoUX0Ubl0aCqqs2LhsLKu5KjF02FtS5MXXZSFDjrsTIpXXvhjAMRZqmfo0gI0ejkbdcLiU1EeSHJkniouvYtr2wLEtgq1x8HPQdMiPCHIm5Ev0vtNF4PJblYiyE+PPO6vtCrlarOb/DmP4RG1v5iDaiYYmg88Cd33fo+74zmUy4MFzqHxbzQHwRHFD0jxhzySFf5EFU2J56ANW5V8WYyhwej8d3xOOJWpJl2cdms9lVjWmD3yEuMcp/phusPNr4fVL7bDrF/OaCOBk6Fc50OhVkIshHGnXDNRJEpW6pAygaY8EF1XOoG+TDn0wESbMlRbbmqEKPWy5/jaB2wTexKE6cb+XyAWJv6/X6UHG/wG/hq5pbLGimhp6pcigUIY8dVYkxeKjkkLNjutrqukq9gf8ynE6nLbWA5+HQeNaN/wCQANA0XehyXgAAAABJRU5ErkJggg==);
      position: relative;
    }

    &.half {
      position: absolute;
      margin: 0px;
    }

    &.small {
      height: 12px;
      width: 12px;
    }
  }
}
</style>
